"use client";
import React from "react";

import { cn } from "@/storyblok/utils/cn";
import { FaArrowRightLong } from "react-icons/fa6";

export default function ButtonDefault({
  onClick = () => {},
  buttonText,
  buttonType = "glowingOrange",
}) {
  const buttonClasses = cn(
    "group flex flex-row font-medium text-white font-semibold",
    {
      "drop-shadow-custom-orange": buttonType === "glowingOrange",
      "drop-shadow-custom-dark": buttonType === "glowingDark",
      "drop-shadow-none": buttonType === "orange",
      "drop-shadow-none": buttonType === "dark",
      "drop-shadow-none items-center gap-2": buttonType === "textOnly",
    }
  );

  const buttonPartClasses = cn({
    "bg-primary-accent group-hover:bg-primary-accent-dark py-1":
      buttonType === "glowingDark" || buttonType === "dark",
    "bg-tertiary-accent group-hover:bg-tertiary-accent-dark py-1":
      buttonType === "glowingOrange" || buttonType === "orange",
    "bg-transparent text-black ": buttonType === "textOnly",
  });

  const leftClasses = cn(buttonPartClasses, "w-4", {
    "button-angle-left": buttonType === "glowingDark" || buttonType === "dark",
  });

  const rightClasses = cn(buttonPartClasses, "w-4", {
    "button-angle-right":
      buttonType === "glowingOrange" || buttonType === "orange",
  });

  const middleClasses = cn(buttonPartClasses, {
    "pr-2": buttonType === "glowingOrange" || buttonType === "orange",
    "pl-2": buttonType === "glowingDark" || buttonType === "dark",
    "text-black bg-transparent hover:underline": buttonType === "textOnly",
  });

  return (
    <button
      onClick={onClick}
      className={cn("focus:outline-none min-w-[48px] min-h-[48px]", {
        "hover:underline": buttonType === "textOnly",
      })}
    >
      <span className={buttonClasses}>
        {buttonType !== "textOnly" && <span className={leftClasses}></span>}
        <span className={middleClasses}>{buttonText}</span>
        <span className={rightClasses}>
          {buttonType === "textOnly" && (
            <FaArrowRightLong className="inline-block text-base" />
          )}
        </span>
      </span>
    </button>
  );
}
